//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
/**@type {import('../types').DataType<import('./types').JourneyDataModel>} */

var JOURNEY_DATA_TYPE = {
  data: {
    url: '/backend/journeys/audience',
    itemUrl: '/backend/journeys/{id}',
    createItemUrl: '/backend/journeys',
    dataKey: 'journeys',
    idKeyProp: 'Id',
    onBeforeRequest: function onBeforeRequest(props, request) {
      if (request.type === 'loadView') {
        if (props.dataProps && props.dataProps.viewType) {
          return {
            query: {
              viewType: props.dataProps.viewType
            }
          };
        }
      } else if (request.type === 'deleteItem') {
        return {
          query: {
            deleteProjects: true,
            deleteDiagrams: true
          }
        };
      }
    }
  },
  placeholders: {
    label: function label(data) {
      return data.Name;
    },
    type: function type(data) {
      return data.Type;
    },
    icon: function icon(data) {
      return data && data.Type && data.Type.toLowerCase() === 'episode' ? 'episode' : 'journey';
    }
  },
  columns: [{
    id: 'Name',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.Link, {
        icon: data.Type,
        text: data.Name,
        value: "/EOS/Engage/#engage/Journeys/".concat(data.Id)
      });
    },
    serverSort: true
  }, {
    id: 'Description',
    formatter: function formatter(_ref2) {
      var data = _ref2.data;
      return React.createElement(Formatter.Text, {
        value: data.Description
      });
    },
    width: {
      xs: 0,
      sm: 'auto'
    }
  }, {
    id: 'Enabled',
    formatter: function formatter(_ref3) {
      var data = _ref3.data;
      return React.createElement(Formatter.Switch, {
        value: Boolean(data.Enabled)
      });
    },
    serverSort: true,
    width: 120
  }, {
    id: 'Audience',
    children: 'Contacts',
    formatter: function formatter(_ref4) {
      var data = _ref4.data;
      return React.createElement(React.Fragment, null, data.Type === 'episode' ? data.Lists && data.Lists.map(function (list) {
        return React.createElement(Formatter.Link, {
          key: list.Id,
          text: list.Name,
          icon: "list"
        });
      }) : data.Personas && data.Personas.map(function (persona) {
        return React.createElement(Formatter.Link, {
          key: persona.Id,
          text: persona.Name,
          icon: "persona"
        });
      }));
    } // inMemorySort: data =>
    //   data.Type +
    //   (data.Lists && data.Lists.length ? data.Lists[0].Name : '') +
    //   (data.Personas && data.Personas.length ? data.Personas[0].Name : ''),

  }, {
    id: 'Author',
    children: 'Author',
    formatter: function formatter(_ref5) {
      var data = _ref5.data; // if (!data || !data.AuthorUserId) return '-';

      return React.createElement(Formatter.Placeholders, {
        template: "{label}",
        dataType: "userId",
        id: data.AuthorUserId
      });
    },
    serverSort: true,
    width: {
      xs: 0,
      sm: 0,
      md: 150
    }
  }, {
    id: 'LastUpdatedUTC',
    children: 'Last Updated',
    formatter: function formatter(_ref6) {
      var data = _ref6.data;
      return React.createElement(Formatter.DateTime, {
        value: data.LastUpdatedUTC
      });
    },
    serverSort: true,
    width: {
      xs: 0,
      sm: 0,
      md: 200
    }
  }, {
    id: 'ContactsCount',
    icon: 'contacts',
    numeric: true,
    formatter: function formatter(_ref7) {
      var data = _ref7.data;
      return React.createElement(Formatter.Text, {
        value: data.ContactsCount
      });
    },
    serverSort: false,
    inMemorySort: false,
    width: 100
  }],
  thumbnail: {
    icon: function icon(data) {
      return data.Type;
    },
    text: function text(data) {
      return data.Name;
    }
  },
  contextMenu: [{
    type: 'delete'
  }]
};
export default JOURNEY_DATA_TYPE;